import { FareStatusType, TableExemptionType } from '../../../typesFinancial';

const CONFIRMED_EXEMPTION_STATUSES: FareStatusType[] = [
  'PROCESSING',
  'BILLED',
  'REBILLED',
];

export function isExemptionConfirmed(status?: FareStatusType | null) {
  return !!status && CONFIRMED_EXEMPTION_STATUSES.includes(status);
}

export function getFareExemptionTooltip(status?: FareStatusType | null) {
  if (isExemptionConfirmed(status)) {
    return 'Todas as tabelas desta tarifa estão isentas. A isenção foi confirmada e nada foi enviado ao RM.';
  }
  return 'Todas as tabelas desta tarifa estão isentas. Ela não é enviada ao RM e fica como faturada quando você confirmar a isenção.';
}

export function getTableExemptionTooltip(exemption: TableExemptionType) {
  return `Isenta: ${exemption.description}. Os itens são gerados com valor zero, a tabela não é enviada ao RM e não recebe desconto.`;
}
